// FIXME: this file should be auto-generated
export enum ColumnType {
  AUTO_NUMBER = 'AUTO_NUMBER',
  CHECKBOX = 'CHECKBOX',
  COLLABORATOR = 'COLLABORATOR',
  CREATED_AT = 'CREATED_AT',
  CREATED_BY = 'CREATED_BY',
  CURRENCY = 'CURRENCY',
  DATETIME = 'DATETIME',
  EMAIL = 'EMAIL',
  FORMULA = 'FORMULA',
  INTEGRATION_REFERENCE = 'INTEGRATION_REFERENCE',
  LONG_TEXT = 'LONG_TEXT',
  LOOKUP = 'LOOKUP',
  MULTI_ATTACHMENT = 'MULTI_ATTACHMENT',
  MULTI_SELECT = 'MULTI_SELECT',
  NOOP = 'NOOP',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RATING = 'RATING',
  RECORD_REFERENCE = 'RECORD_REFERENCE',
  ROLLUP = 'ROLLUP',
  SELECT = 'SELECT',
  TEXT = 'TEXT',
  UNIQUE_ID = 'UNIQUE_ID',
  STATUS = 'STATUS',
  SUBTABLE = 'SUBTABLE',
  PROGRESS = 'PROGRESS',
}

export enum NumberFormat {
  CURRENCY = 'CURRENCY',
  DECIMAL = 'DECIMAL',
  DECIMAL_WITH_COMMAS = 'DECIMAL_WITH_COMMAS',
  PERCENTAGE = 'PERCENTAGE',
}

export enum FormulaResultType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
}

export enum IDFormat {
  PREFIXDATETIMEHASH = 'PREFIXDATETIMEHASH',
  PREFIXHASH = 'PREFIXHASH',
}

export enum Language {
  en = 'en',
  zh = 'zh',
}

export enum StatusType {
  DOING = "DOING",
  DONE = "DONE",
  PENDING = "PENDING",
}

export enum DateComparisonOptions {
  EXACT_DATE = 'EXACT_DATE',
  NUM_DAYS_AGO = 'NUM_DAYS_AGO',
  NUM_DAYS_FROM_NOW = 'NUM_DAYS_FROM_NOW',
  ONE_MONTH_AGO = 'ONE_MONTH_AGO',
  ONE_MONTH_FROM_NOW = 'ONE_MONTH_FROM_NOW',
  ONE_WEEK_AGO = 'ONE_WEEK_AGO',
  ONE_WEEK_FROM_NOW = 'ONE_WEEK_FROM_NOW',
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  YESTERDAY = 'YESTERDAY',
}

export enum AttachmentFileTypeOptions {
  EXCEL = 'EXCEL',
  IMAGE = 'IMAGE',
  PDF = 'PDF',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
}

export enum FilterCondition {
  CONTAINS = 'CONTAINS',
  ENDS_WITH = 'ENDS_WITH',
  EQUALS = 'EQUALS',
  EQUALS_ANY_OF = 'EQUALS_ANY_OF',
  EQUALS_NONE_OF = 'EQUALS_NONE_OF',
  EQUALS_EACH_OF = 'EQUALS_EACH_OF',
  FILE_NAME = 'FILE_NAME',
  FILE_TYPE = 'FILE_TYPE',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  HAS_ALL_OF = 'HAS_ALL_OF',
  HAS_ANY_OF = 'HAS_ANY_OF',
  HAS_NONE_OF = 'HAS_NONE_OF',
  INTERSECTS = 'INTERSECTS',
  IS_EMPTY = 'IS_EMPTY',
  IS_NOT_EMPTY = 'IS_NOT_EMPTY',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_CONTAINS = 'NOT_CONTAINS',
  NOT_EQUAL = 'NOT_EQUAL',
  STARTS_WITH = 'STARTS_WITH',
}

export enum FilterType {
  ATTACHMENT = 'ATTACHMENT',
  CHECKBOX = 'CHECKBOX',
  COLLABORATOR = 'COLLABORATOR',
  CREATED_BY = 'CREATED_BY',
  DATE = 'DATE',
  EMAIL = 'EMAIL',
  LOOKUP = 'LOOKUP',
  MULTI_SELECT = 'MULTI_SELECT',
  NUMBER = 'NUMBER',
  PHONE = 'PHONE',
  RECORD_REFERENCE = 'RECORD_REFERENCE',
  SELECT = 'SELECT',
  STATUS = 'STATUS',
  TEXT = 'TEXT',
}

export enum OperatorType {
  AND = 'AND',
  OR = 'OR',
}
